import React from 'react';
import AgreementsListContainer from './AgreementsListContainer';
import { AgreementsViewComponent } from './Agreements.types';

const AgreementsView: AgreementsViewComponent = () => {
  return <AgreementsListContainer />;
};
export default AgreementsView;
